module.exports = __webpack_public_path__ + "components/country-flag/static/tw-4ce8d6fa2357b77519f2a3096f8fc37f.svg";